import "./ContactUs.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import HeroIntroduction from "./sections/HeroIntroduction";
import ContactUs from "./sections/ContactUs";
import CustomerReviews from "@/pages/Home/sections/CustomerReviews";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <NavigationHeader />
      <HeroIntroduction />
      <ContactUs />
      <CustomerReviews />
      <Footer />
    </div>;
}